<!-- Component can be used in microscope and periscope -->
<template>
  <div class="conversation-list">
    <ConversationListItem
      v-for="conv in conversations"
      :key="conv.id"
      :conversation="conv"
      :active="conv.id === activeConversationId"
      @click="$emit('select', conv.id)"
    />
  </div>
</template>

<script setup lang="ts">
import type { ConversationListItem as ConversationListItemType } from '@staff/shared'
import ConversationListItem from './ConversationListItem.vue'

defineProps<{
  conversations: ConversationListItemType[]
  activeConversationId?: string | null
}>()

defineEmits<{
  (e: 'select', id: string): void
}>()
</script>

<style scoped lang="scss">
.conversation-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
}
</style>
